module.exports = __webpack_public_path__ + "img/blog-7.8e18266d.jpg";